module.exports = __webpack_public_path__ + "static/media/loading1.8d0b9b09.gif";